import womensHealthTestimonials from '@/app/[locale]/womens-health/_data/womensHealthTestimonials';
import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';

const WomensHealthTestimonials = () => {
  return (
    <LandingPageTestimonials
      data-cy="womens-health-testimonials"
      testimonials={womensHealthTestimonials}
      theme="green"
    />
  );
};

export default WomensHealthTestimonials;
